<template>
  <ValidationProvider :name="$t('fix_number')" :rules="{ required: true }" v-slot="{ errors }">
    <v-autocomplete
      :items="fixNumberList"
      item-text="Number"
      item-value="Number"
      :disabled="isAllTextFieldDisable"
      :search-input.sync="searchInput"
      v-model="editedFix"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_results')"
      :ref="refName"
      @keyup.enter="keyupEnter"
      :error-messages="errors[0]"
      @change="setFixNumber"
      @click="setFix(fatherFixNumber)"
      :loading="isLoading"
      return-object
    >
      <template v-slot:append-item>
        <div v-intersect="isScrollBarBottom" />
      </template>
      <template v-slot:label>
        <span class="red--text">
          <strong>* </strong>
        </span>
        {{ $t('fix_number') }}
      </template>
      <template v-slot:selection="{ item }">
        {{ setSelectText(item) }}
      </template>
    </v-autocomplete>
  </ValidationProvider>
</template>
<script>
import { HttpFix } from '@/js/http-Manager'

export default {
  name: 'FixNumberAutocomplete',
  props: {
    editedQuotationIndex: {
      type: Number
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    refName: {
      type: String
    },
    fatherFixNumber: {
      type: String
    },
    customerId: {
      type: String
    },
    licensePlate: {
      type: String
    }
  },
  data: () => ({
    fixNumberList: [],
    searchInput: null,
    page: 1,
    perPage: 10,
    tempWatchNumber: '',
    searchCount: 0,
    getIntersectingObj: null,
    isFinish: false,
    isLoading: false,
    editedFix: { Number: '' },
    defaultFix: { Number: '' }
  }),
  async mounted () {
    await this.setFix(this.fatherFixNumber)
  },
  watch: {
    async searchInput (val) {
      this.tempWatchNumber = val
      this.page = 1
      this.fixNumberList = []
      this.isFinish = true
      await this.getNumberCount()
      await this.getNumber()
      this.isFinish = false
    },

    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getNumber()
        }
      }
    },
    async fatherFixNumber (val) {
      await this.setFix(val)
    }
  },
  methods: {
    async setFix (val) {
      if (!val) {
        this.tempWatchNumber = ''
        this.page = 1
        this.fixNumberList = []
        this.isFinish = true
        await this.getNumberCount()
        await this.getNumber()
        this.isFinish = false
        this.editedFix = JSON.parse(JSON.stringify(this.defaultFix))
      } else {
        this.tempWatchNumber = val
        this.page = 1
        this.fixNumberList = []
        this.isFinish = true
        await this.getNumberCount()
        await this.getNumber()
        this.isFinish = false
        this.editedFix = JSON.parse(JSON.stringify({ Number: val }))
      }
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    setFixNumber () {
      this.$emit('setFixNumber', this.editedFix)
    },
    async getNumberCount () {
      let param = {
        searchNumber: this.tempWatchNumber,
        customerId: this.customerId,
        licensePlate: this.licensePlate
      }
      let response = await HttpFix.GetFixNumberCountByCustomerId(param)
      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getNumber () {
      if (this.searchCount > (this.page - 1) * this.perPage && this.searchCount !== 0) {
        this.isLoading = true
        let param = {
          SearchNumber: this.tempWatchNumber,
          CustomerId: this.customerId,
          LicensePlate: this.licensePlate,
          Page: this.page,
          PerPage: this.perPage
        }
        let response = await HttpFix.GetFixNumberByCustomerId(param)
        if (response.status === 200) {
          this.fixNumberList = [...this.fixNumberList, ...response.data.Data]
        } else {
          this.fixNumberList = []
        }
        this.isLoading = false
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    },
    setSelectText (item) {
      return item.Number
    }
  }
}
</script>
